import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import BackgroundImg from "gatsby-background-image"

const ServicesSix = ({ children }) => {
  const data = useStaticQuery(graphql`
    query {
      desktop: file(relativePath: { eq: "wwd6.jpg" }) {
        childImageSharp {
          fixed(quality: 80, width: 640) {
            ...GatsbyImageSharpFixed_withWebp
          }
        }
      }
    }
  `)

  return (
    <BackgroundImg
      Tag="div"
      fluid={data.desktop.childImageSharp.fixed}
      backgroundColor={`#0F2765`}
    >
      {children}
    </BackgroundImg>
  )
}

export default ServicesSix
